import axios from 'axios';
import api from './api';
import { AppBranding, AppBrandingInput } from '../types/branding';
import { DEFAULT_BRANDING, resolveLogoUrl } from '../constants/branding';

const publicApiUrl = () => process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export function normalizeBranding(data?: Partial<AppBranding> | null): AppBranding {
  return {
    site_title: data?.site_title || DEFAULT_BRANDING.title,
    site_short_title: data?.site_short_title || DEFAULT_BRANDING.shortTitle,
    site_subtitle: data?.site_subtitle || DEFAULT_BRANDING.subtitle,
    logo_path: data?.logo_path ?? null,
    logo_url: resolveLogoUrl(data?.logo_url, data?.logo_path),
    copyright_text: data?.copyright_text || DEFAULT_BRANDING.copyright,
  };
}

export const brandingAPI = {
  getBranding: async (): Promise<{ success: boolean; data: AppBranding }> => {
    const response = await axios.get(`${publicApiUrl()}/settings/branding`);
    return {
      ...response.data,
      data: normalizeBranding(response.data.data),
    };
  },

  updateBranding: async (payload: AppBrandingInput) => {
    const response = await api.put('/settings/branding', payload);
    return {
      ...response.data,
      data: normalizeBranding(response.data.data),
    };
  },

  uploadLogo: async (file: File) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/settings/branding/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return {
      ...response.data,
      data: normalizeBranding(response.data.data),
    };
  },

  removeLogo: async () => {
    const response = await api.delete('/settings/branding/logo');
    return {
      ...response.data,
      data: normalizeBranding(response.data.data),
    };
  },
};

export default brandingAPI;
